<template>
  <div>
    <p class="text-base font-bold">
      {{ name }}
    </p>
    <div class="flex flex-row">
      <div v-for="(item, index) in cardSlots" :key="index">
        <Card :card="item.card" :show="item.show" :is-extra-card="index === extraCardIndex"></Card>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Hand } from "@models/Hand";
import Card from "@/components/Card.vue";
import { computed, ref } from "vue";
import LineItemSelectControl from "./LineItemSelectControl.vue";

interface Props {
  extraCard: boolean;
  hand: Hand;
  name: string;
  isOffline: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["rename"]);

const showRename = ref(false);
const newName = ref(props.name);

const handleRename = () => {
  emit("rename", newName.value);
  showRename.value = false;
};

const cardSlots = computed(() => {
  const slots = [...props.hand.cardSlots];
  if (!props.extraCard && slots.length > 5) {
    slots.splice(5, 1);
  }
  return slots;
});

const extraCardIndex = props.extraCard && cardSlots.value[2].show ? 2 : 5;
</script>
